import useSWR from "swr";
import Stripe from "stripe";
import { fetcherV2 } from "@gogive/services";
import { routes } from "@/services/account.service";

export type StripeConnectUrls = {
  returnUrl: string;
  refreshUrl: string;
};

export function useStripeConnectLink(
  enabled: boolean,
  urls?: () => StripeConnectUrls
) {
  const { data, error, isLoading } = useSWR(
    () => {
      if (!enabled) return undefined;
      const resolved = urls
        ? urls()
        : {
            returnUrl: window.location.href,
            refreshUrl: window.location.href,
          };
      return [routes.getStripeConnectLink, resolved] as const;
    },
    fetcherV2<Stripe.AccountLink | undefined>
  );

  return {
    isLoading,
    error,
    stripeConnectLink: data,
  };
}
